import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import Asset from "../../../../../model/asset/Asset";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import AssetFragmentFormBody from "./AssetFragmentFormBody";
import {Option} from "ts-option";
import AssetMaterialsBreakdown from "../../../../../model/asset/AssetMaterialsBreakdown";
import AssetMaterialsBreakdownTable from "../assetMaterials/AssetMaterialsBreakdownTable";
import AssetForm from "../../form/AssetForm";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid
	 * @param {Asset} asset asset data to update
	 */
	onSubmit: (asset: Asset) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Asset to edit.
	 */
	asset: Asset;
	/**
	 *  List of materials for each merchant
	 */
	materialsBreakdown: Option<AssetMaterialsBreakdown[]>;
}

type IState = BaseFormViewState<AssetForm>;

export default class AssetFragmentFormView extends BaseFormView<AssetForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: AssetForm.createFromAsset(this.props.asset),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<AssetFragmentFormBody form={this.state.form}
									   onFieldChange={this.onFieldChanged}
									   onFieldCompleted={this.onFieldCompleted}
									   onFocusChange={this.onFocusChange}
									   onFieldsChange={this.onFieldsChanged}/>
				<AssetMaterialsBreakdownTable materialsBreakdown={this.props.materialsBreakdown}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update asset"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit, () => {});
		});
	}
}
